export default "__VITE_ASSET__yXLy6a9a__"